function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_request_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M269.5 128h-28.4v55.3H138.6l-46.5 38.9v-38.9H28.3V78h93.8V49.6H0v162.5h63.8v71.4l85-71.4h120.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M207.1 127.4l20-20.1-29.6-29.5h86V49.4h-86L226.9 20l-20-20-63.6 63.6z"
})));